import { isError, isSwallowedError, isUnparsedError, isWarning } from "./parse-error";
import { MaybeParsedError, ParsedAsError, ParsedAsWarning, UnparsedError } from "./parse-error-as";

export const handleParsedError =
({
  onWarning,
  onError,
  onUnparsed,
}: {
  onWarning: (title: string, message: string, parsed: ParsedAsWarning<any>) => void;
  onError: (message: string, parsed: ParsedAsError<any>) => void;
  onUnparsed: (message: string, unparsed: UnparsedError) => void;
}) =>
(error: MaybeParsedError<any>) => {
  if (isWarning(error)) onWarning(error.parsed.title, error.parsed.message, error);
  if (isError(error)) onError(error.parsed.message, error);
  if (isUnparsedError(error)) onUnparsed(error.message, error);

  if (isSwallowedError(error)) {
    console.warn('Swallowed error', error)
  }

  return {
    rethrow: !isSwallowedError(error)
  };
};
